export default __webpack_public_path__ + "static/peter-marshall-44ab531d7dac40af10f484787dceece9.jpg";